import { memo } from 'react';
import FJTextToImageResolution from '../view/FJTextToImageResolution';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { setSliceResolution } from '../../../../redux/slices/FJSliceTextToImage';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJTextToImageDataConfig from '../../../../config/dataConfig/FJTextToImageDataConfig';

const FJTextToImageResolutionContainer = memo(function FJTextToImageResolutionContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const curResolution = useSelector(state => state.textToImage.curResolution);
    const curModel = useSelector(state => state.textToImage.curModel);

    const changeResolution = useCallback(
        resolution => {
            dispatch(setSliceResolution(resolution));
        },
        [dispatch],
    );
    const curModelObj = useMemo(() => {
        return FJTextToImageDataConfig.MODELS.find(item => item.value === curModel);
    }, [curModel]);
    return (
        <FJTextToImageResolution
            curResolution={curResolution}
            changeResolution={changeResolution}
            curModelObj={curModelObj}
        />
    );
});

export default FJTextToImageResolutionContainer;
